import { NgClass } from '@angular/common';
import { Component, ViewEncapsulation, input } from '@angular/core';

export interface TableCell {
  text: string;
  orange?: boolean;
  color?: 'orange' | 'blue' | 'green';
  bold?: boolean;
  muted?: boolean;
  image?: string;
  imageAlt?: string;
}

export interface TableData {
  headers: (string | TableCell)[];
  rows: (string | TableCell)[][];
  footnotes?: string[];
}

@Component({
  selector: 'ds-table-block',
  templateUrl: './table-block.html',
  styleUrl: './table-block.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass],
})
export class TableBlockComponent {
  readonly data = input.required<TableData>();
  readonly striped = input(true);
  readonly compact = input(false);

  isString(cell: string | TableCell): cell is string {
    return typeof cell === 'string';
  }

  getCellClasses(cell: TableCell): Record<string, boolean> {
    const color = cell.color || (cell.orange ? 'orange' : undefined);
    return {
      's__table-block__td--orange': color === 'orange',
      's__table-block__td--blue': color === 'blue',
      's__table-block__td--green': color === 'green',
      's__table-block__td--bold': !!cell.bold,
      's__table-block__td--muted': !!cell.muted,
    };
  }
}
